import { render } from "./projectMonitoring.vue?vue&type=template&id=dabf51c0"
import script from "./projectMonitoring.vue?vue&type=script&lang=js"
export * from "./projectMonitoring.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__